import React, { useState, useEffect } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import user from "../../../assets/images/user/User.webp";
import notification from "../../../assets/images/alerts/Notification.webp";
import card from "../../../assets/images/payments/Creditcard.webp";
import raz from "../../../assets/images/payments/razropay.webp";
import "./UpiPayment.css";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import { useDbContext } from "../../../context/DbContext";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectActiveFyid } from "../../../app/financialYearSlice";
import { selectActiveLocation } from "../../../app/locationSlice";
import { useActiveFyLimits } from "../../../utils/fyDateValidation";

function UpiPayment() {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const navigate = useNavigate();
  const activeFyid = useSelector(selectActiveFyid);
  const activeLocation = useSelector(selectActiveLocation);
  const fyid = activeFyid || Number(sessionStorage.getItem("selectedFyId")) || Number(localStorage.getItem("selectedFyId")) || 0;
  const locationId = activeLocation?.id || Number(sessionStorage.getItem("loginLocationId")) || Number(localStorage.getItem("loginLocationId")) || 0;
  const { minDate, maxDate, validateAndAlert, isDateInFy } = useActiveFyLimits();
  const [dateValue, setDateValue] = useState(moment());
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [error, setError] = useState(null);

  const [userType, setuserType] = useState("");
  const [userCode, setuserCode] = useState("");
  const [userAccno, setuserAccno] = useState("");

  useEffect(() => {
    const storeduType = sessionStorage.getItem("userType");
    if (storeduType) {
      setuserType(storeduType);
      if (storeduType === "CUSTOMERS") {
        const customers = sessionStorage.getItem("CustomerName");
        const accno = sessionStorage.getItem("Uaccno");
        setuserCode(customers);
        setuserAccno(accno);
      }
    }
  }, []);

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    // Clamp to active FY limits
    if (minDate && formattedToday < minDate) return minDate;
    if (maxDate && formattedToday > maxDate) return maxDate;
    return formattedToday;
  };

  const initialDateVal = getCurrentDate();

  useEffect(() => {
    if (minDate) {
      const today = moment();
      const minMom = moment(minDate);
      const maxMom = maxDate ? moment(maxDate) : null;
      if (today.isBefore(minMom)) {
        setDateValue(minMom);
      } else if (maxMom && today.isAfter(maxMom)) {
        setDateValue(maxMom);
      }
    }
  }, [minDate, maxDate]);

  const [customerData, setCustomerData] = useState({
    entryNo: "",
    date: initialDateVal,
    accountName: "",
    agent: "",
    duration: "",
    accountNo: "",
    add1: "",
    add2: "",
    city: "",
    pincode: "",
    contactPerson: "",
    mobile: "",
    email: "",
    tele: "",
    narration: "",
    amount: 0,
    rate: "",
    gm: 0.0,
    intperc: "",
  });
  //////console.log("customerdata===", customerData);

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) {
      return "Good morning";
    } else if (hour < 17) {
      return "Good afternoon";
    } else if (hour < 21) {
      return "Good evening";
    } else {
      return "Good night";
    }
  };

  const [receiptOrderid, setReceiptOrderid] = useState(null);
  const [selectedcashAcc, setselectedcashAcc] = useState(null);
  const [cRate, setCrate] = useState("");
  const [ledBalance, setLedBalance] = useState("0.00");
  const [razorpayKeys, setRazorpayKeys] = useState({
    key_id: "",
    key_secret: "",
  });

  // Fetch all required data on component mount
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        // Fetch receipt order data
        const receiptResponse = await axios.get(
          `${apiBaseUrl}/common/selectAllformDatas/${dbCode}`
        );
        const receiptOrder = receiptResponse.data.find(
          (item) => item.fmrTypeOfVoucher === "Scheme Receipt Order"
        );
        setReceiptOrderid(
          receiptOrder
            ? {
                formId: receiptOrder.fmrEntryNo,
                abbreviation: receiptOrder.fmrAbbreviation,
              }
            : null
        );

        // Fetch cash account data
        const cashAccResponse = await axios.get(
          `${apiBaseUrl}/main/SchRec_caba/${dbCode}`
        );
        const cashAcc = cashAccResponse.data.find(
          (item) => item.LedName === "CASH"
        );
        setselectedcashAcc(
          cashAcc
            ? {
                ledcode: cashAcc.ledcode,
                ledname: cashAcc.LedName,
              }
            : null
        );

        // Fetch current gold rate
        const rateResponse = await axios.get(
          `${apiBaseUrl}/main/getGoldRate/${dbCode}?date=${customerData.date || ""}`
        );
        setCrate(rateResponse.data[0]?.currentRate || "");

        // Fetch Razorpay keys
        const keysResponse = await axios.get(
          `${apiBaseUrl}/common/razorpay-keys/${dbCode}`
        );
        if (keysResponse.data.key_id && keysResponse.data.key_secret) {
          setRazorpayKeys({
            key_id: keysResponse.data.key_id,
            key_secret: keysResponse.data.key_secret,
          });
        }
      } catch (error) {
        console.error("Error fetching initial data:", error.message);
      }
    };

    fetchAllData();
  }, [apiBaseUrl, dbCode]);

  // Fetch customer data when userCode changes
  useEffect(() => {
    const fetchCustomerData = async () => {
      if (!userCode) return;

      try {
        // Get customer scheme data
        const schemeResponse = await axios.get(
          `${apiBaseUrl}/main/findbyAccname/${userCode}/${dbCode}`
        );
        const schemeData = schemeResponse.data[0] || {};

        // Get customer ledger details
        const ledgerResponse = await axios.get(
          `${apiBaseUrl}/common/ledDetails/${userCode}/${dbCode}`
        );
        const ledgerData = ledgerResponse.data[0] || {};

        // Get ledger balance
        const balanceResponse = await axios.get(
          `${apiBaseUrl}/common/ledgerbalance/${dbCode}/${parseInt(userCode)}`
        );
        const balance = balanceResponse.data[0]?.balance || "0.00";

        // Update all customer data at once
        setCustomerData((prev) => ({
          ...prev,
          accountNo: schemeData.auto || "",
          agent: schemeData.agent || "",
          accountName: ledgerData.LedName || "",
          add1: ledgerData.add1 || "",
          add2: ledgerData.add2 || "",
          pincode: ledgerData.PinNo || "",
          mobile: ledgerData.Mobile || "",
          email: ledgerData.Email || "",
          tele: ledgerData.Telno || "",
        }));

        setLedBalance(balance);
      } catch (error) {
        console.error("Error fetching customer data:", error.message);
      }
    };

    fetchCustomerData();
  }, [userCode, dbCode, apiBaseUrl]);

  // Load Razorpay script on component mount
  useEffect(() => {
    const loadScript = async () => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      document.body.appendChild(script);
    };

    loadScript();
  }, []);

  // Function to save the receipt after successful payment
  const saveReceipt = async (oid) => {
    if (
      !amount ||
      !receiptOrderid ||
      !selectedcashAcc ||
      !cRate ||
      !userCode ||
      !selectedcashAcc.ledcode ||
      !customerData.accountNo ||
      !customerData.agent
    ) {
      console.error("Missing required data for receipt");
      return;
    }

    try {
      const gmValue = (parseFloat(amount) / parseFloat(cRate)).toFixed(4);

      const receiptData = {
        statementType: "SchRec_insert",
        cashacc: selectedcashAcc.ledcode,
        rate: cRate,
        date: getCurrentDate(),
        salesMan: 0,
        totalamount: parseFloat(amount).toFixed(2),
        totalgm: gmValue,
        agCode: 0,
        formId: receiptOrderid.formId,
        fyid: fyid,
        Location: locationId,
        type: [
          {
            SINo: 1,
            name: userCode,
            agent: customerData.agent,
            accountNumber: customerData.accountNo,
            amount: parseFloat(amount),
            gm: parseFloat(gmValue),
            narration: `Online Payment on ${getCurrentDate()}   orderId= ${oid}`,
            printgm: 1,
            billed: 0,
          },
        ],
      };

      const response = await axios.post(
        `${apiBaseUrl}/main/saveSchRec/${dbCode}`,
        receiptData
      );

      if (response.data.success) {
        alert("Receipt saved successfully");
        navigate("/home")
      } else {
        console.error("Failed to save receipt");
      }
    } catch (error) {
      console.error("Error saving receipt:", error);
    }
  };

  const createOrder = async (amount) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/common/create-razorpay-order`,
        {
          amount: amount * 100,
          currency: "INR",
          receipt: `receipt_${Date.now()}`,
          notes: {
            date: dateValue.format("YYYY-MM-DD"),
            purpose: "Wallet top-up",
          },
          key_id: razorpayKeys.key_id,
          key_secret: razorpayKeys.key_secret,
        }
      );
      return response.data;
    } catch (err) {
      console.error("Error creating order:", err);
      throw new Error("Failed to create payment order");
    }
  };

  const verifyPayment = async (paymentResponse) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/common/verify-razorpay-payment/${dbCode}`,
        {
          orderId: paymentResponse.razorpay_order_id,
          paymentId: paymentResponse.razorpay_payment_id,
          signature: paymentResponse.razorpay_signature,
          key_secret: razorpayKeys.key_secret,
          amount:amount*100,
          schAccno:userAccno,
          customerDetails: {
            name: customerData.accountName,
            email: customerData.email,
            contact: customerData.mobile,
          },
        }
      );
      return response.data.success;
    } catch (err) {
      console.error("Error verifying payment:", err);
      return false;
    }
  };

  const handlePayment = async () => {
    if (!amount || isNaN(amount) || amount <= 0) {
      setError("Please enter a valid amount");
      return;
    }

    // Check if we have all required customer data
    if (!customerData.accountNo || !customerData.agent) {
      setError(
        "Customer account information is not loaded yet. Please wait..."
      );
      return;
    }

    setLoading(true);
    setError(null);
    setPaymentSuccess(false);

    try {
      // Step 1: Create order on your server
      const order = await createOrder(amount);

      // Step 2: Initialize Razorpay checkout
      const options = {
        key: razorpayKeys.key_id,
        amount: order.amount,
        currency: order.currency,
        name: customerData.accountName,
        description: "Wallet Top-up",
        order_id: order.id,
        handler: async function (response) {
          // Step 3: Verify payment signature on your server
          const isPaymentValid = await verifyPayment(response);

          if (isPaymentValid) {
            setPaymentSuccess(true);
            // Save the receipt after successful payment verification
            await saveReceipt(order.id);
          } else {
            setError("Payment verification failed. Please contact support.");
            console.error("Payment verification failed");
          }
        },
        prefill: {
          name: customerData.accountName,
          email: customerData.email,
          contact: customerData.mobile,
        },
        notes: {
          date: dateValue.format("YYYY-MM-DD"),
          purpose: "Wallet top-up",
        },
        theme: {
          color: "#0054C3",
        },
      };

      const paymentObject = new window.Razorpay(options);

      // Handle payment failures
      paymentObject.on("payment.failed", function (response) {
        setError(`Payment failed: ${response.error.description}`);
        console.error("Payment failed:", response);
      });

      // Open the Razorpay payment modal
      paymentObject.open();
    } catch (err) {
      setError(err.message || "Payment processing failed. Please try again.");
      console.error("Payment error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-screen bg-[#0054C3] flex flex-col">
      {/* Header Section */}
      <div className="h-[15%] flex flex-col p-5">
        <div className="w-full h-1/2 flex">
          <div className="w-1/2 h-full flex items-center gap-1">
            <div className="w-[53px] h-[53px] bg-white flex items-center justify-center rounded-full">
              <img src={user} alt="user" className="w-7 h-7" />
            </div>
            <div className="w-2/3 h-[53px] flex justify-center flex-col gap-1">
              <label className="text-white font-Poppins text-[10px] font-medium leading-none tracking-wider text-left">
                {getGreeting()}
              </label>
              <label className="text-white font-Poppins text-[14px] font-medium leading-none tracking-wider text-left">
                {`${customerData.accountName}`}
              </label>
            </div>
          </div>
          <div className="w-1/2 h-full flex justify-end items-center">
            <div className="w-[23px] h-[23px] flex items-center justify-center">
              <img
                src={notification}
                alt="notification"
                className="w-full h-full"
              />
            </div>
          </div>
        </div>
        <div className="h-1/2 flex">
          <div className="w-1/2 h-full flex items-center">
            <label className="text-white font-Poppins text-[14px] font-medium leading-none tracking-wider text-left">
              Current Balance
            </label>
          </div>
          <div className="w-1/2 h-full flex justify-end items-center">
            <div className="w-[112px] h-[26px] flex items-center justify-center rounded-[17px] bg-white">
              <label className="text-[#ff0001] font-Poppins text-[14px] font-medium leading-[100%] tracking-[2%] text-left overflow-x-auto whitespace-nowrap">
                {`₹ ${ledBalance}`}
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Form Section */}
      <div className="w-full h-[85%] flex justify-center relative">
        <div className="w-[92%] h-[88px] absolute flex flex-col gap-3 items-center justify-center top-0 rounded-2xl shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] bg-white">
          <img src={card} alt="credit card" className="w-[34px] h-[34px]" />
          <label className="text-[#0054c3] font-Poppins text-[12px] font-medium leading-[100%] tracking-[2%] text-left">
            Add money
          </label>
        </div>

        <div className="w-full h-full mt-[44px] pt-[50px] rounded-t-2xl shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] bg-white flex flex-col items-center gap-3">
          {/* Date Picker */}
          <label className="text-black w-[92%] font-Poppins text-[14px] mt-[30px] font-medium leading-[18px] tracking-[-0.17px] text-left">
            Date
          </label>
          <DatePicker
            value={dateValue}
            onChange={(newValue) => {
              if (newValue) {
                const formatted = newValue.format("YYYY-MM-DD");
                if (!isDateInFy(formatted)) {
                  alert("Date incompatible with financial year");
                  return;
                }
              }
              setDateValue(newValue);
            }}
            disabledDate={(current) => {
              if (!current) return false;
              if (minDate && current < moment(minDate).startOf("day")) return true;
              if (maxDate && current > moment(maxDate).endOf("day")) return true;
              return false;
            }}
            id="date"
            className="w-[92%] h-[42px] rounded-[5px] shadow-[0_0_2px_0_rgba(0,0,0,0.25)] bg-white rschemediaborder"
          />

          {/* Amount Input */}
          <label className="text-black w-[92%] font-Poppins text-[14px] font-medium leading-[18px] tracking-[-0.17px] text-left">
            Amount (INR)
          </label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            id="amount"
            placeholder="Enter amount"
            className="w-[92%] h-[42px] rounded-[5px] shadow-[0_0_2px_0_rgba(0,0,0,0.25)] bg-white rschemediaborder px-3"
          />

          {/* Payment Method Selection */}
          <label className="text-black w-[92%] font-Poppins text-[14px] font-medium leading-[18px] tracking-[-0.17px] text-left">
            Select Payment Type
          </label>
          <div className="w-[92%] h-[55px] rounded-[25px] shadow-[0_0_2px_0_rgba(0,0,0,0.25)] bg-white upiborder flex items-center justify-center relative">
            <img
              src={raz}
              alt="razorpay"
              className="w-[129px] h-[29px] absolute left-5"
            />
            <input
              type="radio"
              checked
              readOnly
              className="w-[15px] h-[15px] absolute right-5"
            />
          </div>

          {/* Status Messages */}
          {error && (
            <div className="w-[92%] text-red-500 font-Poppins text-sm">
              {error}
            </div>
          )}
          {paymentSuccess && (
            <div className="w-[92%] text-green-500 font-Poppins text-sm">
              Payment successful! Your wallet will be updated shortly.
            </div>
          )}

          {/* Spacer */}
          <div className="w-[92%] h-[60px]"></div>

          {/* Submit Button */}
          <button
            onClick={handlePayment}
            disabled={loading || !customerData.accountNo || !customerData.agent}
            className={`w-[92%] h-[60px] rounded-[10px] shadow-[0_0_2px_0_rgba(0,0,0,0.25)] ${
              loading || !customerData.accountNo || !customerData.agent
                ? "bg-[#0054C3]/70"
                : "bg-[#0054C3]"
            } text-white font-Poppins text-[18px] font-semibold leading-[18px] tracking-[-0.17px] text-center cursor-pointer`}
          >
            {loading ? "Processing..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpiPayment;
